import "./style.scss";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import ProjectResourceItem from "../../components/ProjectResourceItem";
import { mainButton } from "@telegram-apps/sdk";
import { useEffect, useState } from "react";
import { navigateToPage } from "../../redux/slices/windowSlice";
import { useLoadProducts } from "../../hooks/useLoadProducts";

const ProjectResources = () => {
    const dispatch = useAppDispatch();
    const { loadProducts, isLoading: isLoadingProducts, data: products, isError: isErrorProducts } = useLoadProducts();

    const { projectResources } = useAppSelector(
        (state: RootState) => state.windowSlice
    );

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        mainButton.mount();
        mainButton.setParams({
            backgroundColor: "#34C759",
            hasShineEffect: true,
            isEnabled: true,
            isLoaderVisible: false,
            isVisible: true,
            text: "Увеличить лимиты",
            textColor: "#ffffff",
        });
        mainButton.onClick(() => {
            loadProducts();
            mainButton.setParams({
                isLoaderVisible: isLoadingProducts,
            });
        });

        return () => {
            mainButton.setParams({
                isVisible: false,
            });
            mainButton.unmount();
        };
    }, []);

    const go = () => {
        // dispatch(navigateToPage("products"));
    }

    

    useEffect(() => {
        if (!isLoadingProducts && products && !isErrorProducts) {
            dispatch(navigateToPage("products"));
        } 
    }, [loadProducts, products, isErrorProducts, isLoadingProducts]);


    return (
        <div className="project-resources">
            <div className="project-resources_container">
                <div className="project-resources_wrapper">
                    <div className="project-resources_billing">
                        {projectResources.billing_information.amounts.map(
                            (item, index) => (
                                <span
                                    className="project-resources_charge-info"
                                    key={index}>
                                    Оплата за текущие подключения <br />
                                    {item.amount.toFixed(2)} {item.currency}{" "}
                                    спишется{" "}
                                    {new Date(
                                        projectResources.billing_information.renew_at
                                    ).toLocaleString("ru-RU", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                    })}
                                    .
                                </span>
                            )
                        )}
                        {projectResources.fees.amounts.map((item, index) => (
                            <span
                                className="project-resources_charge-info"
                                key={index}>
                                Обслуживание 0.5% с оплаты
                                <br />
                                {item.amount.toFixed(2)} {item.currency}{" "}
                                спишется{" "}
                                {new Date(
                                    projectResources.fees.next_charge
                                ).toLocaleString("ru-RU", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                })}
                                .
                            </span>
                        ))}
                    </div>
                    <div className="project-resources_items" onClick={loadProducts}>
                        {projectResources.resources.map((item, index) => (
                            <ProjectResourceItem
                                key={index}
                                item={item}
                                products={projectResources.products}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectResources;
